module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-3@2x.efefdf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-3@2x.png
// module id = e1wh
// module chunks = 18